export default function loadingReducer(state = {}, action) {
  const { type, payload } = action;
  const error = (payload !== undefined) ? payload : {};
  const matches = /(.*)_(REQUEST|SUCCESS|FAILURE)/.exec(type);
  const { status } = error;
  if (!matches) return state;

  const [, requestName, requestState] = matches;
  return {
    ...state,
    [requestName]: {
      running: requestState === 'REQUEST',
      success: requestState === 'SUCCESS',
      httpCode: status,
    },
  };
}
